angular
    .module('app')
    .component('usersEdit', {
        templateUrl: '/templates/pages/users/usersEdit/usersEdit.html',
        controller: 'UsersEditController',
        controllerAs: 'vm',
    });